// extracted by mini-css-extract-plugin
module.exports = {"login":"UiD1w","mounted":"cLkBt","surface":"maH0I","window":"pDSSV","logo":"VQhjp","bannerWrapper":"wGiwL","icon":"QZMza"};